import { apiService } from './apiService';

export const notificationService = {
  async getNotifications(params?: { userId?: string; unreadOnly?: boolean; compact?: boolean; limit?: number }) {
    if (params?.userId) {
      return await notificationService.getByUser(params.userId, {
        ...(params.unreadOnly ? { isRead: false } : {}),
        compact: params.compact,
        limit: params.limit,
      });
    }

    return await apiService.get('/notifications');
  },

  async getByUser(userId: string, filters?: { isRead?: boolean; compact?: boolean; limit?: number }) {
    const params = new URLSearchParams();
    if (filters?.isRead !== undefined) params.append('isRead', String(filters.isRead));
    if (filters?.compact) params.append('compact', 'true');
    if (filters?.limit) params.append('limit', String(filters.limit));
     
    const query = params.toString();
    return await apiService.get(`/notifications/user/${userId}${query ? `?${query}` : ''}`);
  },

  async markAsRead(id: string | number) {
    return await apiService.put(`/notifications/${id}/read`, {});
  },

  async markAllAsRead(userId: string) {
    return await apiService.put(`/notifications/user/${userId}/read-all`, {});
  },

  async delete(id: string | number) {
    return await apiService.delete(`/notifications/${id}`);
  },

  async deleteAllByUser(userId: string) {
    return await apiService.delete(`/notifications/user/${userId}`);
  },

  async create(data: any) {
    return await apiService.post('/notifications', data);
  },

  async registerPushToken(token: string, platform: string) {
    return await apiService.post('/notifications/register-token', { token, platform });
  },

  async sendTestPush(data: { userId?: string | number; userIds?: Array<string | number>; title?: string; message?: string; channelId?: string; sound?: string }) {
    return await apiService.post('/notifications/test-push', data);
  },

  async sendLocationReminder(data: { userIds: Array<string | number>; message: string; channels: { sms: boolean; push: boolean; sound: boolean } }) {
    return await apiService.post('/notifications/location-reminder', data);
  },
};
